import * as React from 'react'

import { Card, ErrorAlert, IconNotification } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import slackLogo from '@webapp/platform/integrations/assets/images/slack.png'
import { SlackUserLinkingSection } from '@webapp/platform/integrations/feature-sets/SlackUserLinkingSection'
import { NotConnectedView } from './components/NotConnectedView'
import { SlackIntegrationSectionLoader } from './components/SlackIntegrationSectionLoader'
import messages from './messages'
import {
  SlackIntegrationSectionStyled,
  SlackIntegrationSectionLogoContainer,
} from './styles/SlackIntegrationSectionStyled'
import { useSlackIntegrationSection } from './useSlackIntegrationSection'

export const SlackIntegrationSection = () => {
  const intl = useProcurifyIntl()
  const { isIntegrated, handleConnect, isLoading, error } =
    useSlackIntegrationSection()

  const renderContent = () => {
    if (isLoading) {
      return <SlackIntegrationSectionLoader />
    }

    if (error) {
      return (
        <ErrorAlert icon={<IconNotification />}>
          {intl.formatMessage(messages.errorMessage)}
        </ErrorAlert>
      )
    }

    if (isIntegrated) {
      return (
        <Card>
          <Card.Content>
            <SlackUserLinkingSection />
          </Card.Content>
        </Card>
      )
    }

    return <NotConnectedView onConnect={handleConnect} />
  }

  return (
    <SlackIntegrationSectionStyled>
      <SlackIntegrationSectionLogoContainer>
        <img src={slackLogo} alt='Slack' height={60} />
      </SlackIntegrationSectionLogoContainer>
      {renderContent()}
    </SlackIntegrationSectionStyled>
  )
}
